// src/composables/useNetworkToast.js
import { ref, onMounted, onUnmounted } from "vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export function useNetworkToast() {
  console.log("starting useNetwork toast");
  const isOnline = ref(navigator.onLine);

  const updateStatus = () => {
    isOnline.value = navigator.onLine;

    if (isOnline.value) {
      toast.success("You are back online ✅", { autoClose: 3000 });
    } else {
      toast.error("You are offline ❌", {
        autoClose: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }

    console.debug(
      "[Network] Current status:",
      isOnline.value ? "Online" : "Offline"
    );
  };

  onMounted(() => {
    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);
  });

  onUnmounted(() => {
    window.removeEventListener("online", updateStatus);
    window.removeEventListener("offline", updateStatus);
  });

  return { isOnline };
}
